import React, { useState, useEffect } from "react";
import "../App.css";
import HeroSection from "../components/HeroSection";
import GridMediaLayout from "../components/GridMediaLayout";
import Gap from "../components/Gap";
import CrossfadeImageColumns from "../components/CrossfadeImageColumns";
import FullWidthCarousel from "../components/FullWidthCarousel";
import ResponsiveImageCarousel from "../components/ResponsiveImageCarousel";
// import TwoColumnMedia from "../components/TwoColumnMedia";
import LazyLoad from "react-lazy-load";
// import CenterMedia from "../components/CenterMedia";
// import ThreeColumns from "../components/ThreeColumns";
// import ImageCarousel from "../components/ImageCarousel";
import Footer from "../components/Footer";

function Film35mm() {
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  const alagButNiceImages = [
    {
      type: "image",
      src: "../Film-35mm/alag-but-nice/aaj-ka-post.webp",
      alt: "Film 35mm Alag But Nice Image 1",
      row: 1,
      column: 1,
    },
    {
      type: "image",
      src: "../Film-35mm/alag-but-nice/ok.webp",
      alt: "Film 35mm Alag But Nice Image 2",
      row: 1,
      column: 2,
    },
    {
      type: "image",
      src: "../Film-35mm/alag-but-nice/z.webp",
      alt: "Film 35mm Alag But Nice Image 3",
      row: 1,
      column: 3,
    },
  ];

  const carlottaCafeImages = [
    [
      {
        src: "../Film-35mm/carlotta-cafe/1.webp",
        alt: "File 35mm Carlotta Cafe Image 1",
      },
      {
        src: "../Film-35mm/carlotta-cafe/2.webp",
        alt: "File 35mm Carlotta Cafe Image 2",
      },
      {
        src: "../Film-35mm/carlotta-cafe/3.webp",
        alt: "File 35mm Carlotta Cafe Image 3",
      },
    ],
  ];

  const vanyaVogueImages = [
    [
      {
        type: "image",
        src: "../Film-35mm/vanya-vogue/vanya-hb.webp",
        alt: "Film 35mm Vanya Vogue Image 1",
      },
    ],
  ];

  // const portobelloVolvoImages = [
  //   {
  //     type: "image",
  //     src: "../Film-35mm/portobello-volvo/volvo-2.webp",
  //     alt: "Film 35mm Portobello Volvo Image 1",
  //     row: 1,
  //     column: 1,
  //   },
  //   {
  //     type: "image",
  //     src: "../Film-35mm/portobello-volvo/Volvo.webp",
  //     alt: "Film 35mm Portobello Volvo Image 2",
  //     row: 1,
  //     column: 2,
  //   },
  // ];

  const electricCinemaImages = [
    {
      src: "../Film-35mm/electric-cinema-notting-hill/EC-2.webp",
      alt: "Film 35mm Electric Cinema Notting Hill Image 1",
    },
    {
      src: "../Film-35mm/electric-cinema-notting-hill/Electric-Cinema.webp",
      alt: "Film 35mm Electric Cinema Notting Hill Image 2",
    },
  ];

  const modernArchitectureImages = [
    {
      type: "image",
      src: "../Film-35mm/modern-architecture/000139840017.webp",
      alt: "Film 35mm Mordern Architecture Image 1",
      row: 1,
      column: 1,
    },
    {
      type: "image",
      src: "../Film-35mm/modern-architecture/000139840018.webp",
      alt: "Film 35mm Mordern Architecture Image 2",
      row: 1,
      column: 2,
    },
    {
      type: "image",
      src: "../Film-35mm/modern-architecture/000139840019.webp",
      alt: "Film 35mm Mordern Architecture Image 3",
      row: 1,
      column: 3,
    },
  ];

  // const sevenSistersImages = [
  //   [
  //     {
  //       src: "../Film-35mm/seven-sisters/A.webp",
  //       alt: "Film 35mm Seven Sisters Image 1",
  //     },
  //     {
  //       src: "../Film-35mm/seven-sisters/B.webp",
  //       alt: "Film 35mm Seven Sisters Image 2",
  //     },
  //     {
  //       src: "../Film-35mm/seven-sisters/C.webp",
  //       alt: "Film 35mm Seven Sisters Image 3",
  //     },
  //     {
  //       src: "../Film-35mm/seven-sisters/D.webp",
  //       alt: "Film 35mm Seven Sisters Image 4",
  //     },
  //     {
  //       src: "../Film-35mm/seven-sisters/E.webp",
  //       alt: "Film 35mm Seven Sisters Image 5",
  //     },
  //   ],
  // ];

  // const houseOfAlamsImages = [
  //   [
  //     {
  //       src: "../Film-35mm/house-of-alams/Vaibhav-Yadav1.webp",
  //       alt: "Film 35mm House of Alams Image 1",
  //     },
  //     {
  //       src: "../Film-35mm/house-of-alams/Vaibhav-Yadav2.webp",
  //       alt: "Film 35mm House of Alams Image 2",
  //     },
  //     {
  //       src: "../Film-35mm/house-of-alams/Vaibhav-Yadav3.webp",
  //       alt: "Film 35mm House of Alams Image 3",
  //     },
  //     {
  //       src: "../Film-35mm/house-of-alams/Vaibhav-Yadav4.webp",
  //       alt: "Film 35mm House of Alams Image 4",
  //     },
  //     {
  //       src: "../Film-35mm/house-of-alams/Vaibhav-Yadav5.webp",
  //       alt: "Film 35mm House of Alams Image 5",
  //     },
  //   ],
  // ];

  const brightonSpringImages = [
    {
      type: "image",
      src: "../Film-35mm/brighton-spring-and-dehleez/Dehleez.webp",
      alt: "Film 35mm Brighton Spring and Dahleez Image 1",
      row: 1,
      column: 1,
    },
  ];

  const kenwood_carousel_images = [
    { src: "../Home/kenwood/7.webp", alt: "Kenwood Image 7" },
    { src: "../Home/kenwood/8.webp", alt: "Kenwood Image 8" },
    { src: "../Home/kenwood/9.webp", alt: "Kenwood Image 9" },
    { src: "../Home/kenwood/10.webp", alt: "Kenwood Image 10" },
    { src: "../Home/kenwood/11.webp", alt: "Kenwood Image 11" },
    { src: "../Home/kenwood/12.webp", alt: "Kenwood Image 12" },
    { src: "../Home/kenwood/13.webp", alt: "Kenwood Image 13" },
    { src: "../Home/kenwood/14.webp", alt: "Kenwood Image 14" },
    { src: "../Home/kenwood/15.webp", alt: "Kenwood Image 15" },
    { src: "../Home/kenwood/16.webp", alt: "Kenwood Image 16" },
    { src: "../Home/kenwood/1.webp", alt: "Kenwood Image 1" },
    { src: "../Home/kenwood/2.webp", alt: "Kenwood Image 2" },
    { src: "../Home/kenwood/3.webp", alt: "Kenwood Image 3" },
    { src: "../Home/kenwood/4.webp", alt: "Kenwood Image 4" },
    { src: "../Home/kenwood/5.webp", alt: "Kenwood Image 5" },
    { src: "../Home/kenwood/6.webp", alt: "Kenwood Image 6" },
    { src: "../Home/kenwood/7.webp", alt: "Kenwood Image 7" },
    { src: "../Home/kenwood/8.webp", alt: "Kenwood Image 8" },
    { src: "../Home/kenwood/9.webp", alt: "Kenwood Image 9" },
    { src: "../Home/kenwood/10.webp", alt: "Kenwood Image 10" },
    { src: "../Home/kenwood/11.webp", alt: "Kenwood Image 11" },
    { src: "../Home/kenwood/12.webp", alt: "Kenwood Image 12" },
    { src: "../Home/kenwood/13.webp", alt: "Kenwood Image 13" },
    { src: "../Home/kenwood/14.webp", alt: "Kenwood Image 14" },
    { src: "../Home/kenwood/15.webp", alt: "Kenwood Image 15" },
    { src: "../Home/kenwood/16.webp", alt: "Kenwood Image 16" },
    { src: "../Home/kenwood/1.webp", alt: "Kenwood Image 1" },
    { src: "../Home/kenwood/2.webp", alt: "Kenwood Image 2" },
    { src: "../Home/kenwood/3.webp", alt: "Kenwood Image 3" },
    { src: "../Home/kenwood/4.webp", alt: "Kenwood Image 4" },
    { src: "../Home/kenwood/5.webp", alt: "Kenwood Image 5" },
    { src: "../Home/kenwood/6.webp", alt: "Kenwood Image 6" },
    { src: "../Home/kenwood/7.webp", alt: "Kenwood Image 7" },
    { src: "../Home/kenwood/8.webp", alt: "Kenwood Image 8" },
    { src: "../Home/kenwood/9.webp", alt: "Kenwood Image 9" },
    { src: "../Home/kenwood/10.webp", alt: "Kenwood Image 10" },
    { src: "../Home/kenwood/11.webp", alt: "Kenwood Image 11" },
    { src: "../Home/kenwood/12.webp", alt: "Kenwood Image 12" },
    { src: "../Home/kenwood/13.webp", alt: "Kenwood Image 13" },
    { src: "../Home/kenwood/14.webp", alt: "Kenwood Image 14" },
    { src: "../Home/kenwood/15.webp", alt: "Kenwood Image 15" },
    { src: "../Home/kenwood/16.webp", alt: "Kenwood Image 16" },
    { src: "../Home/kenwood/1.webp", alt: "Kenwood Image 1" },
    { src: "../Home/kenwood/2.webp", alt: "Kenwood Image 2" },
    { src: "../Home/kenwood/3.webp", alt: "Kenwood Image 3" },
    { src: "../Home/kenwood/4.webp", alt: "Kenwood Image 4" },
    { src: "../Home/kenwood/5.webp", alt: "Kenwood Image 5" },
    { src: "../Home/kenwood/6.webp", alt: "Kenwood Image 6" },
  ];

  const villa_carlotta_carousel_images = [
    {
      src: "../Film-35mm/villa-carlotta/8.webp",
      alt: "Villa Carlotta Image 8",
    },
    {
      src: "../Film-35mm/villa-carlotta/9.webp",
      alt: "Villa Carlotta Image 9",
    },
    {
      src: "../Film-35mm/villa-carlotta/10.webp",
      alt: "Villa Carlotta Image 10",
    },
    {
      src: "../Film-35mm/villa-carlotta/11.webp",
      alt: "Villa Carlotta Image 11",
    },
    {
      src: "../Film-35mm/villa-carlotta/12.webp",
      alt: "Villa Carlotta Image 12",
    },
    {
      src: "../Film-35mm/villa-carlotta/13.webp",
      alt: "Villa Carlotta Image 13",
    },
    {
      src: "../Film-35mm/villa-carlotta/14.webp",
      alt: "Villa Carlotta Image 14",
    },
    {
      src: "../Film-35mm/villa-carlotta/15.webp",
      alt: "Villa Carlotta Image 15",
    },
    {
      src: "../Film-35mm/villa-carlotta/16.webp",
      alt: "Villa Carlotta Image 16",
    },
    {
      src: "../Film-35mm/villa-carlotta/17.webp",
      alt: "Villa Carlotta Image 17",
    },
    {
      src: "../Film-35mm/villa-carlotta/18.webp",
      alt: "Villa Carlotta Image 18",
    },
    {
      src: "../Film-35mm/villa-carlotta/8.webp",
      alt: "Villa Carlotta Image 8",
    },
    {
      src: "../Film-35mm/villa-carlotta/9.webp",
      alt: "Villa Carlotta Image 9",
    },
    {
      src: "../Film-35mm/villa-carlotta/10.webp",
      alt: "Villa Carlotta Image 10",
    },
    {
      src: "../Film-35mm/villa-carlotta/11.webp",
      alt: "Villa Carlotta Image 11",
    },
    {
      src: "../Film-35mm/villa-carlotta/12.webp",
      alt: "Villa Carlotta Image 12",
    },
    {
      src: "../Film-35mm/villa-carlotta/13.webp",
      alt: "Villa Carlotta Image 13",
    },
    {
      src: "../Film-35mm/villa-carlotta/14.webp",
      alt: "Villa Carlotta Image 14",
    },
    {
      src: "../Film-35mm/villa-carlotta/15.webp",
      alt: "Villa Carlotta Image 15",
    },
    {
      src: "../Film-35mm/villa-carlotta/16.webp",
      alt: "Villa Carlotta Image 16",
    },
    {
      src: "../Film-35mm/villa-carlotta/17.webp",
      alt: "Villa Carlotta Image 17",
    },
    {
      src: "../Film-35mm/villa-carlotta/18.webp",
      alt: "Villa Carlotta Image 18",
    },
    {
      src: "../Film-35mm/villa-carlotta/8.webp",
      alt: "Villa Carlotta Image 8",
    },
    {
      src: "../Film-35mm/villa-carlotta/9.webp",
      alt: "Villa Carlotta Image 9",
    },
    {
      src: "../Film-35mm/villa-carlotta/10.webp",
      alt: "Villa Carlotta Image 10",
    },
    {
      src: "../Film-35mm/villa-carlotta/11.webp",
      alt: "Villa Carlotta Image 11",
    },
    {
      src: "../Film-35mm/villa-carlotta/12.webp",
      alt: "Villa Carlotta Image 12",
    },
    {
      src: "../Film-35mm/villa-carlotta/13.webp",
      alt: "Villa Carlotta Image 13",
    },
    {
      src: "../Film-35mm/villa-carlotta/14.webp",
      alt: "Villa Carlotta Image 14",
    },
    {
      src: "../Film-35mm/villa-carlotta/15.webp",
      alt: "Villa Carlotta Image 15",
    },
    {
      src: "../Film-35mm/villa-carlotta/16.webp",
      alt: "Villa Carlotta Image 16",
    },
    {
      src: "../Film-35mm/villa-carlotta/17.webp",
      alt: "Villa Carlotta Image 17",
    },
    {
      src: "../Film-35mm/villa-carlotta/18.webp",
      alt: "Villa Carlotta Image 18",
    },
    {
      src: "../Film-35mm/villa-carlotta/8.webp",
      alt: "Villa Carlotta Image 8",
    },
    {
      src: "../Film-35mm/villa-carlotta/9.webp",
      alt: "Villa Carlotta Image 9",
    },
    {
      src: "../Film-35mm/villa-carlotta/10.webp",
      alt: "Villa Carlotta Image 10",
    },
    {
      src: "../Film-35mm/villa-carlotta/11.webp",
      alt: "Villa Carlotta Image 11",
    },
    {
      src: "../Film-35mm/villa-carlotta/12.webp",
      alt: "Villa Carlotta Image 12",
    },
    {
      src: "../Film-35mm/villa-carlotta/13.webp",
      alt: "Villa Carlotta Image 13",
    },
    {
      src: "../Film-35mm/villa-carlotta/14.webp",
      alt: "Villa Carlotta Image 14",
    },
    {
      src: "../Film-35mm/villa-carlotta/15.webp",
      alt: "Villa Carlotta Image 15",
    },
    {
      src: "../Film-35mm/villa-carlotta/16.webp",
      alt: "Villa Carlotta Image 16",
    },
    {
      src: "../Film-35mm/villa-carlotta/17.webp",
      alt: "Villa Carlotta Image 17",
    },
    {
      src: "../Film-35mm/villa-carlotta/18.webp",
      alt: "Villa Carlotta Image 18",
    },
    {
      src: "../Film-35mm/villa-carlotta/8.webp",
      alt: "Villa Carlotta Image 8",
    },
    {
      src: "../Film-35mm/villa-carlotta/9.webp",
      alt: "Villa Carlotta Image 9",
    },
    {
      src: "../Film-35mm/villa-carlotta/10.webp",
      alt: "Villa Carlotta Image 10",
    },
    {
      src: "../Film-35mm/villa-carlotta/11.webp",
      alt: "Villa Carlotta Image 11",
    },
    {
      src: "../Film-35mm/villa-carlotta/12.webp",
      alt: "Villa Carlotta Image 12",
    },
    {
      src: "../Film-35mm/villa-carlotta/13.webp",
      alt: "Villa Carlotta Image 13",
    },
    {
      src: "../Film-35mm/villa-carlotta/14.webp",
      alt: "Villa Carlotta Image 14",
    },
    {
      src: "../Film-35mm/villa-carlotta/15.webp",
      alt: "Villa Carlotta Image 15",
    },
    {
      src: "../Film-35mm/villa-carlotta/16.webp",
      alt: "Villa Carlotta Image 16",
    },
    {
      src: "../Film-35mm/villa-carlotta/17.webp",
      alt: "Villa Carlotta Image 17",
    },
    {
      src: "../Film-35mm/villa-carlotta/18.webp",
      alt: "Villa Carlotta Image 18",
    },
  ];

  // const vanyaVogueImages = [
  //   {
  //     type: "image",
  //     src: "../Film-35mm/vanya-vogue/vanya-hb.webp",
  //     alt: "Film 35mm Vanya Vogue Image 1",
  //     row: 1,
  //     column: 1,
  //   },
  // ];

  const brighton_spring_and_dehleez_carousel_images = [
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/A.webp",
      alt: "Brighton Spring and Dehleez Image 1-Copy",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/B.webp",
      alt: "Brighton Spring and Dehleez Image 102",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/C.webp",
      alt: "Brighton Spring and Dehleez Image 103",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/D.webp",
      alt: "Brighton Spring and Dehleez Image 104",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/E.webp",
      alt: "Brighton Spring and Dehleez Image 106",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/F.webp",
      alt: "Brighton Spring and Dehleez Image 107",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/H.webp",
      alt: "Brighton Spring and Dehleez Image 108",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/A.webp",
      alt: "Brighton Spring and Dehleez Image 1-Copy",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/B.webp",
      alt: "Brighton Spring and Dehleez Image 102",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/C.webp",
      alt: "Brighton Spring and Dehleez Image 103",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/D.webp",
      alt: "Brighton Spring and Dehleez Image 104",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/E.webp",
      alt: "Brighton Spring and Dehleez Image 106",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/F.webp",
      alt: "Brighton Spring and Dehleez Image 107",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/H.webp",
      alt: "Brighton Spring and Dehleez Image 108",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/A.webp",
      alt: "Brighton Spring and Dehleez Image 1-Copy",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/B.webp",
      alt: "Brighton Spring and Dehleez Image 102",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/C.webp",
      alt: "Brighton Spring and Dehleez Image 103",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/D.webp",
      alt: "Brighton Spring and Dehleez Image 104",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/E.webp",
      alt: "Brighton Spring and Dehleez Image 106",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/F.webp",
      alt: "Brighton Spring and Dehleez Image 107",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/H.webp",
      alt: "Brighton Spring and Dehleez Image 108",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/A.webp",
      alt: "Brighton Spring and Dehleez Image 1-Copy",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/B.webp",
      alt: "Brighton Spring and Dehleez Image 102",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/C.webp",
      alt: "Brighton Spring and Dehleez Image 103",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/D.webp",
      alt: "Brighton Spring and Dehleez Image 104",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/E.webp",
      alt: "Brighton Spring and Dehleez Image 106",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/F.webp",
      alt: "Brighton Spring and Dehleez Image 107",
    },
    {
      src: "../Film-35mm/brighton-spring-and-dehleez/H.webp",
      alt: "Brighton Spring and Dehleez Image 108",
    },
  ];

  // const crossfade_image_column_data = [
  //   [
  //     {
  //       src: "../Film-35mm/gucci-londra/11.webp",
  //       alt: "Gucci Londra Image 11",
  //     },
  //     {
  //       src: "../Film-35mm/gucci-londra/12.webp",
  //       alt: "Gucci Londra Image 12",
  //     },
  //     {
  //       src: "../Film-35mm/gucci-londra/14.webp",
  //       alt: "Gucci Londra Image 14",
  //     },
  //     {
  //       src: "../Film-35mm/gucci-londra/25.webp",
  //       alt: "Gucci Londra Image 25",
  //     },
  //     {
  //       src: "../Film-35mm/gucci-londra/29.webp",
  //       alt: "Gucci Londra Image 29",
  //     },
  //   ],
  // ];

  // const sasta_ralph_lauren_images = [
  //   {
  //     type: "image",
  //     src: "../Film-35mm/sasta-ralph-lauren/IMG_4070.webp",
  //     alt: "Film 35mm Sasta Ralph Lauren Image 1",
  //     row: 1,
  //     column: 2,
  //   },
  //   {
  //     type: "image",
  //     src: "../Film-35mm/sasta-ralph-lauren/IMG_4072.webp",
  //     alt: "Film 35mm Sasta Ralph Lauren Image 2",
  //     row: 1,
  //     column: 1,
  //   },
  // ];

  const the_blues_kitchen_images = [
    {
      type: "image",
      src: "../Film-35mm/the-blues-kitchen/tbk.webp",
      alt: "Film 35mm The Blues Kitchen Image 1",
      row: 1,
      column: 1,
    },
  ];

  const swissImages = [
    [
      {
        src: "../Film-35mm/swiss/000142390016.webp",
        alt: "Swiss Image 000142390016",
      },
      {
        src: "../Film-35mm/swiss/000142390019.webp",
        alt: "Swiss Image 000142390019",
      },
      {
        src: "../Film-35mm/swiss/000142390024.webp",
        alt: "Swiss Image 000142390024",
      },
      {
        src: "../Film-35mm/swiss/000142390028.webp",
        alt: "Swiss Image 000142390028",
      },
      {
        src: "../Film-35mm/swiss/000142390029.webp",
        alt: "Swiss Image 000142390029",
      },
      {
        src: "../Film-35mm/swiss/000142390030.webp",
        alt: "Swiss Image 000142390030",
      },
      {
        src: "../Film-35mm/swiss/000142390031.webp",
        alt: "Swiss Image 000142390031",
      },
      {
        src: "../Film-35mm/swiss/000142390033.webp",
        alt: "Swiss Image 000142390033",
      },
      {
        src: "../Film-35mm/swiss/000142390036.webp",
        alt: "Swiss Image 000142390036",
      },
      {
        src: "../Film-35mm/swiss/000142390038.webp",
        alt: "Swiss Image 000142390038",
      },
      {
        src: "../Film-35mm/swiss/000142400005.webp",
        alt: "Swiss Image 000142400005",
      },
      {
        src: "../Film-35mm/swiss/000142400006.webp",
        alt: "Swiss Image 000142400006",
      },
      {
        src: "../Film-35mm/swiss/000142400009.webp",
        alt: "Swiss Image 000142400009",
      },
      {
        src: "../Film-35mm/swiss/000142400010.webp",
        alt: "Swiss Image 000142400010",
      },
      {
        src: "../Film-35mm/swiss/000142400012.webp",
        alt: "Swiss Image 000142400012",
      },
      {
        src: "../Film-35mm/swiss/000142400013.webp",
        alt: "Swiss Image 000142400013",
      },
      {
        src: "../Film-35mm/swiss/000142400015.webp",
        alt: "Swiss Image 000142400015",
      },
      {
        src: "../Film-35mm/swiss/000142400017.webp",
        alt: "Swiss Image 000142400017",
      },
      {
        src: "../Film-35mm/swiss/000142400019.webp",
        alt: "Swiss Image 000142400019",
      },
      {
        src: "../Film-35mm/swiss/000142400020.webp",
        alt: "Swiss Image 000142400020",
      },
      {
        src: "../Film-35mm/swiss/000142400021.webp",
        alt: "Swiss Image 000142400021",
      },
      {
        src: "../Film-35mm/swiss/000142400023.webp",
        alt: "Swiss Image 000142400023",
      },
      {
        src: "../Film-35mm/swiss/000142400024.webp",
        alt: "Swiss Image 000142400024",
      },
      {
        src: "../Film-35mm/swiss/000142400025.webp",
        alt: "Swiss Image 000142400025",
      },
      {
        src: "../Film-35mm/swiss/000142400027.webp",
        alt: "Swiss Image 000142400027",
      },
      {
        src: "../Film-35mm/swiss/000142400028.webp",
        alt: "Swiss Image 000142400028",
      },
      {
        src: "../Film-35mm/swiss/000142400029.webp",
        alt: "Swiss Image 000142400029",
      },
      {
        src: "../Film-35mm/swiss/000142400035.webp",
        alt: "Swiss Image 000142400035",
      },
      {
        src: "../Film-35mm/swiss/000142400036.webp",
        alt: "Swiss Image 000142400036",
      },
    ],
  ];

  const stonehengeImages = [
    [
      { src: "../Film-35mm/stonehenge/1.webp", alt: "Stonehenge Image 1" },
      { src: "../Film-35mm/stonehenge/2.webp", alt: "Stonehenge Image 2" },
      { src: "../Film-35mm/stonehenge/3.webp", alt: "Stonehenge Image 3" },
      { src: "../Film-35mm/stonehenge/4.webp", alt: "Stonehenge Image 4" },
      { src: "../Film-35mm/stonehenge/5.webp", alt: "Stonehenge Image 5" },
    ],
  ];

  const lille_carousel_images = [
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
    { src: "../Film-35mm/lille/1.webp", alt: "lille Image 1" },
    { src: "../Film-35mm/lille/2.webp", alt: "lille Image 2" },
    { src: "../Film-35mm/lille/3.webp", alt: "lille Image 3" },
    { src: "../Film-35mm/lille/4.webp", alt: "lille Image 4" },
    { src: "../Film-35mm/lille/5.webp", alt: "lille Image 5" },
    { src: "../Film-35mm/lille/6.webp", alt: "lille Image 6" },
  ];

  const tenbyWalesImages = [
    [
      { src: "../Film-35mm/tenby-wales/1.webp", alt: "Tenby Wales Image 1" },
      { src: "../Film-35mm/tenby-wales/2.webp", alt: "Tenby Wales Image 2" },
      { src: "../Film-35mm/tenby-wales/3.webp", alt: "Tenby Wales Image 3" },
      { src: "../Film-35mm/tenby-wales/4.webp", alt: "Tenby Wales Image 4" },
      { src: "../Film-35mm/tenby-wales/5.webp", alt: "Tenby Wales Image 5" },
      { src: "../Film-35mm/tenby-wales/6.webp", alt: "Tenby Wales Image 6" },
      { src: "../Film-35mm/tenby-wales/7.webp", alt: "Tenby Wales Image 7" },
    ],
  ];

  const winterWonderlandImages = [
    [
      {
        src: "../Film-35mm/winter-wonderland/1.webp",
        alt: "Winter Wonderland Image 1",
      },
      {
        src: "../Film-35mm/winter-wonderland/2.webp",
        alt: "Winter Wonderland Image 2",
      },
      {
        src: "../Film-35mm/winter-wonderland/3.webp",
        alt: "Winter Wonderland Image 3",
      },
      {
        src: "../Film-35mm/winter-wonderland/4.webp",
        alt: "Winter Wonderland Image 4",
      },
      {
        src: "../Film-35mm/winter-wonderland/5.webp",
        alt: "Winter Wonderland Image 5",
      },
      {
        src: "../Film-35mm/winter-wonderland/6.webp",
        alt: "Winter Wonderland Image 6",
      },
      {
        src: "../Film-35mm/winter-wonderland/7.webp",
        alt: "Winter Wonderland Image 7",
      },
      {
        src: "../Film-35mm/winter-wonderland/8.webp",
        alt: "Winter Wonderland Image 8",
      },
      {
        src: "../Film-35mm/winter-wonderland/9.webp",
        alt: "Winter Wonderland Image 9",
      },
    ],
  ];

  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("scroll", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("scroll", handleUserInteraction);
    };
  }, []);

  return (
    <>
      <HeroSection
        media={{
          type: "image",
          src: "/images/Film-35mm/Merc1.webp",
        }}
      />

      <div className="container">
        <Gap />

        <GridMediaLayout
          mediaItems={alagButNiceImages}
          rows={1}
          columns={3}
          paddingLeft={0}
          paddingRight={0}
        />

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={carlottaCafeImages}
            columns={1}
            interval={2000}
            useDynamicPadding={true}
            maxPadding={300}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        {/* <Gap />

        <GridMediaLayout
          mediaItems={portobelloVolvoImages}
          rows={1}
          columns={2}
          paddingLeft={300}
          paddingRight={300}
        /> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={villa_carlotta_carousel_images}
            timer={3000}
            imageHeight={650}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthCarousel
            images={electricCinemaImages}
            interval={4000}
            paddingLeft={0}
            paddingRight={0}
            animation="slideleft"
          />
        </LazyLoad>
        <Gap />

        <GridMediaLayout
          mediaItems={modernArchitectureImages}
          rows={1}
          columns={3}
          paddingLeft={0}
          paddingRight={0}
        />

        <Gap />

        {/* <div  className="backgroundBlack">
          <Gap />

          <CrossfadeImageColumns
            images={sevenSistersImages}
            columns={1}
            interval={2000}
            paddingLeft={0}
            paddingRight={0}
          />

          <Gap />
        </div> */}

        {/* <CrossfadeImageColumns
            images={houseOfAlamsImages}
            columns={1}
            interval={2000}
            paddingLeft={500}
            paddingRight={500}
          />

          <Gap /> */}

        <GridMediaLayout
          mediaItems={brightonSpringImages}
          rows={1}
          columns={1}
          paddingLeft={0}
          paddingRight={0}
        />

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={kenwood_carousel_images}
            timer={3000}
            imageHeight={600}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={vanyaVogueImages}
            columns={1}
            interval={0}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        {/* <GridMediaLayout
          mediaItems={vanyaVogueImages}
          rows={1}
          columns={1}
          paddingLeft={0}
          paddingRight={0}
        /> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={brighton_spring_and_dehleez_carousel_images}
            timer={3000}
            imageHeight={600}
          />
        </LazyLoad>

        {/* <CrossfadeImageColumns
          images={crossfade_image_column_data}
          columns={1}
          interval={2000}
          paddingLeft={0}
          paddingRight={0}
        /> */}

        {/* <Gap /> */}

        {/* <GridMediaLayout
          mediaItems={sasta_ralph_lauren_images}
          rows={1}
          columns={2}
          paddingLeft={500}
          paddingRight={500}
        /> */}

        {/* <LazyLoad preload>
          <div class="padding-100">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                {
                  type: "image",
                  src: "../Film-35mm/sasta-ralph-lauren/IMG_4070.webp",
                  column: "left",
                },
                {
                  type: "image",
                  src: "../logos-and-png-text/final-logo.webp",
                  column: "center",
                  width: "50%",
                  height: "auto",
                  verticalAlign: "center",
                },
                {
                  type: "image",
                  src: "../Film-35mm/sasta-ralph-lauren/IMG_4072.webp",
                  column: "right",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>*/}

        <Gap />

        <GridMediaLayout
          mediaItems={the_blues_kitchen_images}
          rows={1}
          columns={1}
          paddingLeft={0}
          paddingRight={0}
        />

        {/* <Gap />

        <LazyLoad>
          <div className="padding-400">
            <TwoColumnMedia
              media={[
                { type: "video", src: "../Film-35mm/3-vids/June-21.mp4" },
                { type: "video", src: "../Film-35mm/3-vids/oxford-street.mp4" },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad> */}

        <Gap />

        {/* <div className="crossfade-with-logo"> */}
        {/* Crossfade Image Columns */}
        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={swissImages}
            columns={1}
            interval={3000}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        {/* Logo Overlay */}
        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/hand-drawn-vector-landscape-mountains-600nw-1492891037.webp"
              alt="Unique Overlay Logo"
              className="unique-logo-image"
            />
          </LazyLoad>
        </div>
        {/* </div> */}

        <Gap size={60} />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={stonehengeImages}
            columns={1}
            interval={3000}
            useDynamicPadding={true}
            maxPadding={300}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={lille_carousel_images}
            timer={3000}
            imageHeight={500}
            // gap={10}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={tenbyWalesImages}
            columns={1}
            interval={3000}
            useDynamicPadding={true}
            maxPadding={300}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={winterWonderlandImages}
            columns={1}
            interval={3000}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        {/* <Gap /> */}
      </div>

      <Footer />
    </>
  );
}

export default Film35mm;
